
export default {
 
  handleMarketoForm() {

    $('#leadgen_form #field-country').change(function(){

        let thisCountry = $(this).val();
    
        $('#fg_states_us').slideUp();
        $('#field-states-us').val('');
        $('#field-states-us').prop('required', false);
    
        $('#fg_states_ca').slideUp();
        $('#field-states-ca').val('');
        $('#field-states-ca').prop('required', false);
    
        switch ( thisCountry ) {
    
            case 'United States':
                $('#fg_states_us').slideDown();
                $('#fg_states_us').prop('required', true);
            break;
    
            case 'Canada':
                $('#fg_states_ca').slideDown();
                $('#fg_states_ca').prop('required', true);
            break;
    
        }
      });

  },

  prepopulateMarketoForm() {
    if (window.localStorage.getItem('precisely')) {
      const data = JSON.parse(window.localStorage.getItem('precisely'))
      const fields = [
        'FirstName',
        'LastName',
        'Title',
        'Company',
        'Email',
        'Phone',
        'Country',
        'State',
      ]
      data.forEach(function (a) {
        if (fields.indexOf(a.name) >= 0) {
          $('#leadgen_form input[name="' + a.name + '"], #leadgen_form select[name="' + a.name + '"]').val(a.value).change()
        }
        if (a.name == 'explicitoptin' && a.value == 'true') {
          $('#leadgen_form input[name="explicitoptin"]').prop('checked', true);
        }
      })
    }
  },

  dummyData() {
   
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/marketoform.js